import { Injectable } from '@angular/core';
import { GatewayService } from './gateway.service';
import { ImpresionDocumento } from '../interfaces/impresion.interface';
import { ApiApificado } from '../enums/apificado-api';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ImpresionService {

  constructor(private gatewayServices: GatewayService) { }

  public obtenerDocumentoImpresion(idOrgc: number, idDoc: number, idTipoDoc: number, idOrigen: number, folio: string, rut: string, idTributario: number, esDte: boolean): Observable<ImpresionDocumento> {
    return this.gatewayServices.get<ImpresionDocumento>(`api/Factura/ImprimirDocumentosAsociados?idOrganizacion=${idOrgc}&idDocumento=${idDoc}&idTipoDocumento=${idTipoDoc}&idOrigen=${idOrigen}&folio=${folio}&rut=${rut}&idTipoTributario=${idTributario}&esDte=${esDte}`, ApiApificado.PAGO);
  }
}
